import React, { useRef, useState } from "react"

const ContactForm = ({ type = "general", onClose }) => {
    const isTrade = type === "trade"
    const formName = isTrade ? "trade-enquiries" : "general-enquiries"
    const formId = isTrade ? "trade-form" : "general-form"

    const formRef = useRef(null)
    const [submitted, setSubmitted] = useState(false)
    const [fileName, setFileName] = useState("")

    const handleSubmit = e => {
        e.preventDefault()

        const form = formRef.current
        if (!form) return

        const formData = new FormData(form)

        if (!formData.get("name") || !formData.get("email")) return

        fetch("/", {
            method: "POST",
            body: formData,
        })
            .then(() => {
                form.classList.add("fade-out")
                setTimeout(() => {
                    setSubmitted(true)
                    form.reset()
                    setFileName("")
                }, 750)
            })
            .catch(err => console.error(err))
    }
    if (submitted) {
        return (
            <div className='flex flex-col gap-16' id={`${formId}-thankyou`}>
                <p className='op-60'>Thank you — we’ve received your message. We’ll be in touch shortly.</p>
            </div>
        )
    }
    return (
        <form ref={formRef} netlify-honeypot="bot-field" id={formId} name={formName} method="POST" data-netlify="true" encType="multipart/form-data" className="flex flex-col gap-12" onSubmit={handleSubmit}>
            <input type='hidden' name='form-name' value={formName} />
            <input name='bot-field' className='hide' />
            <Field placeholder='Name*' name='name' required />
            <Field placeholder='Email*' name='email' type='email' required />
            <Field placeholder='Phone' name='phone' />
            <Field placeholder='State' name='state' />
            <TextArea placeholder={isTrade ? "Provide details here*" : "Tell us a little about your project or what you’re looking for*"} name='message' required />
            <div className='flex flex-col gap-32'>
                <div>
                    <label className='f-14 op-60 pointer'>
                        Upload documents ↑ <input className='mt8 hide' onChange={e => setFileName(e.target.files?.[0]?.name || "")} type='file' name='attachments' accept='.pdf,.csv,.xls,.xlsx' />
                    </label>
                    <p className='f-12 op-50 mt8'>{fileName || "Please keep uploads to 8MB and in .pdf or Excel/CSV format"}</p>
                </div>
                <div className='flex align-center gap-12 mt16'>
                    <button className='button' type='submit'>
                        Submit
                    </button>
                </div>
            </div>
        </form>
    )
}

export default ContactForm

const Field = ({ placeholder, name, type = "text", required = false }) => {
    return <input className='input' name={name} type={type} required={required} placeholder={placeholder} />
}

const TextArea = ({ placeholder, name, required = false }) => {
    return <textarea className='input' name={name} required={required} rows={6} placeholder={placeholder} />
}
